import React from "react";
import { Box, BoxProps } from "@chakra-ui/react";
export const PickerArrow = React.forwardRef<HTMLInputElement, BoxProps>(
  ({ ...rest }, ref) => {
    return (
      <Box
        ref={ref}
        boxShadow="1px 1px 2px 0px rgb(96 97 112 / 16%)"
        backgroundColor="bg.white"
        width={"12px"}
        height={"12px"}
        borderColor="transparent"
        borderWidth={1}
        borderStyle={"solid"}
        zIndex={3}
        marginTop={"-6px"}
        {...rest}
      />
    );
  },
);

PickerArrow.displayName = "PickerArrow";
